import { Crown16Regular, Edit16Regular, Eye16Regular, Shield16Regular } from "@fluentui/react-icons";
import type { DirectoryRole } from "@/features/directory/directory";

const ROLE_ICON = {
  owner: Crown16Regular,
  admin: Shield16Regular,
  editor: Edit16Regular,
  viewer: Eye16Regular,
} as const;

/** 역할 표식. 글자와 함께 쓰고, 색은 아이콘 기본색에 둔다. */
export function DirectoryRoleIcon({ role }: { role: DirectoryRole }) {
  const Icon = ROLE_ICON[role];
  return <Icon />;
}
